export default function MySQL_CHARACTER_LENGTH() {
  return (
    <div>
      <h2>MySQL_CHARACTER_LENGTH</h2>    </div>
  );
}